import script from "./acquaint-info-box.vue?vue&type=script&setup=true&lang=ts"
export * from "./acquaint-info-box.vue?vue&type=script&setup=true&lang=ts"

import "./acquaint-info-box.vue?vue&type=style&index=0&id=0742619c&lang=scss"

const __exports__ = script;

export default __exports__